import "./Video.module.css";
import Header from "@/reusable_sections/Header";
import Composer from "./sections/Composer";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
import Gallery from "./sections/Gallery";
export default function VideoPage() {
  return <div>
      <Header />
      <Gallery />
      
      
      <Footer />
    </div>;
}